import type { ReactNode } from "react";

export default function Layout({ children }: { children: ReactNode }) {
  return <main className="p-6 max-w-7xl mx-auto">{children}</main>;
}
